let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ar4WW")).then(() => parcelRequire('jBLEE'));